import React from 'react';
import Select from 'react-select';

const groupStyles = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
};

const customStyles = {
  option: (base, state) => ({
    ...base,
    backgroundColor: state.isFocused ? 'rgba(22,60,77, 1)' : 'rgba(22,60,77, 0.7)',
    color: '#fff',
    padding: '3px 10px',
    paddingLeft: 30,
    fontSize: 18
  }),
  noOptionsMessage: base => ({
    ...base,
    backgroundColor: 'rgba(22,60,77, 0.4)',
    color: '#000',
    opacity: 0.6,
  }),
  groupHeading: base => ({
    ...base,
    paddingTop: 4,
    paddingBottom: 3,
    marginBottom: 0,
    textTransform: 'none',
    fontSize: 15,
    opacity: 0.6,
    backgroundColor: 'rgba(22,60,77, 0.4)',
    color: '#000'
  }),
  group: base => ({
    ...base,
    paddingTop: 0,
    paddingBottom: 0,
  }),
  menuList: base => ({
    ...base,
    paddingTop: 0,
    paddingBottom: 0,
  }),
  control: (base, state) => ({
    ...base,
    backgroundColor: 'transparent',
    borderColor: '#fff',
    minHeight: 28,
    maxHeight: 28,
    color: '#fff',
    borderRadius: 5,
    boxShadow: null,
    '&:hover': {
      borderColor: '#fff',
    },   
  }),
  valueContainer: base => ({
    ...base,
    overflow: 'hidden',
  }),
  input: base => ({
    ...base,
    color: '#fff',
    padding: 0,
    margin: 0,
    fontSize: 18,
  }),
  placeholder: base => ({
    ...base,
    margin: 0,
    fontSize: 18,
    color: 'rgba(255,255,255,0.5)',    
    whiteSpace: 'nowrap',
  }),
  singleValue: base => ({
    ...base,
    color: '#fff',
    padding: 0,
    margin: 0,
    fontSize: 18,   
  }),
  dropdownIndicator: base => ({
    ...base,
    color: '#fff',
    '&:hover': {
      color: '#fff',
    },
    padding: 4
  }),
  indicatorSeparator: () => ({
    display: 'none'
  }),
  menu: base => ({
    ...base,
    marginTop: 0,
    borderRadius: 5,
    borderTopLeftRadius: 0,
  }),
};

const filterOptions = (option, inputValue) => {
  if (!inputValue) {
    return true;
  }
  
  const search = inputValue.toLowerCase().trim();
  const { label, company } = option.data;

  return label.toLowerCase().indexOf(search) > -1 ||
    company.toLowerCase().indexOf(search) > -1
};

export default props => (
  <Select
    styles={customStyles}
    options={props.groupedOptions}
    isSearchable={true}
    placeholder=' -- select person to trade on his/her behalf -- '
    onChange={props.onChange}
    value={props.selectedValue}
    className={props.className}
    filterOption={filterOptions}
  />
);


// WEBPACK FOOTER //
// ./source/components/selectUser.js